<template>
  <div
    :class="{
      active: isActive
    }"
    class="resize-slider"
    @mousedown="onMouseDown"
  >
    <i class="pause-icon"></i>
  </div>
</template>

<script>
/**
 * This is the resize slider for sidebar
 */
export default {
  name: 'ResizeSlider',
  props: [],
  data() {
    return {
      isActive: false
    }
  },
  computed: {},
  methods: {
    onMouseMove(event) {
      if (this.isActive) {
        event.preventDefault()
        const xPosition = event.clientX
        if (xPosition > 200 && xPosition < 500) {
          this.$emit('resize', event.clientX)
        }
      }
    },
    onMouseDown() {
      this.isActive = !this.isActive
      if (this.isActive) {
        document.body.style.cursor = 'col-resize'
      }
    },
    onWindowMouseUp() {
      if (this.isActive) {
        this.isActive = false
        document.body.style.cursor = null
      }
    }
  },
  mounted() {
    window.addEventListener('mousemove', this.onMouseMove)
    window.addEventListener('mouseup', this.onWindowMouseUp)
  },
  beforeDestroy() {
    window.removeEventListener('mousemove', this.onMouseMove)
    window.removeEventListener('mouseup', this.onWindowMouseUp)
  }
}
</script>

<style scoped lang="scss">
@import '~@/styles/_styleConfigurations.scss';

.resize-slider {
  position: absolute;
  width: 2px;
  background-color: transparent;
  top: 0;
  right: 0;
  bottom: 0;
  transition: background-color linear 200ms;

  &:hover,
  &.active {
    cursor: col-resize;
    background-color: $secondary;
  }
}

.pause-icon {
  margin-left: 1px;
  margin-top: 124px;
  transform: translateX(-50%);
}
</style>
